export default {
  enabled: false,
  // fetchUrl: 'http://localhost:9001/api',
  fetchUrl: 'https://work.smarttax.vn/api',
  secretKey: 'Esmart@2025',
};
  